const content: { [key: string]: any } = {
  sessionDetail: 'Session Detail',
};

export default content;
